import React from 'react';
import { useAlertContext } from '../../context/AlertContext';

const Alert = () => {
	const { alerts, dismissAlert } = useAlertContext();

	if (alerts.length === 0) {
		return null;
	}

	return (
		<div id="alert-container" className="fixed-top">
			{alerts.map((alert) => (
				<div
					key={alert.id}
					className={`alert alert-${alert.type} alert-dismissible fade show`}
					role="alert"
				>
					{alert.message}
					<button
						type="button"
						className="close"
						onClick={() => dismissAlert(alert.id)}
						aria-label="Close"
					>
						<span aria-hidden="true">&times;</span>
					</button>
				</div>
			))}
		</div>
	);
};

export default Alert;
